import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { mediaQueries } from '../../../constants';
import { Section } from '../../Section/Section';
import { SectionName } from '../../../observability/tracking/events';

type Props = {
  heading?: string;
  children: ReactNode;
};

/**
 * @deprecated
 * This component has been deprecated. `BlockGrid` should be used instead.
 */
export function TwoColumnGridSection(props: Props) {
  return (
    <Section
      contentWidth="fullWidth"
      heading={props.heading}
      sectionToTrack={SectionName.TwoColumnGridSection}
    >
      <Grid>{props.children}</Grid>
    </Section>
  );
}

const Grid = styled.div`
  display: grid;
  align-items: start;
  gap: 30px;
  grid-template-columns: repeat(1, 1fr);

  ${mediaQueries.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }
`;
